import {toast, ToastOptions} from 'react-toastify';
import {IToastData, ToastMsg} from '@kcast-fe/ui-kit';

export const toastUtils = {
  success: (data: IToastData) => {
    const toastProps: ToastOptions<IToastData> = {
      icon: false,
      autoClose: 3000,
      closeButton: false,
      closeOnClick: true
    };

    toast.success(ToastMsg, {
      ...toastProps,
      data: {
        ...data,
        icon: data.icon ?? 'Warn'
      }
    });
  },
  error: (data: IToastData) => {
    const toastProps: ToastOptions<IToastData> = {
      icon: false,
      autoClose: 5000,
      closeButton: false,
      closeOnClick: true
    };

    toast.error(ToastMsg, {
      ...toastProps,
      data: {
        ...data,
        icon: data.icon ?? 'Warn'
      }
    });
  }
};
